import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import { NumericalInput } from '../../../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';
import { BoxSwitch } from '../../../../../../../atomic/atomicComponentLibrary/switches/boxSwitch/BoxSwitch';
import { Body3, Body4, fontSizes } from '../../../../../../../atomic/text/Text';
import style from '../SimpleTacticStyle.module.css';

export const SimpleLossLimit = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const defaultFn = () => {};
  const isEnabled = tradePlanForm.exitTactics.LOSS_LIMIT ?? false;
  const amount = tradePlanForm.exitTactics.LOSS_LIMIT?.amount ?? 0;
  const setAmount =
    tradePlanForm.exitTactics.LOSS_LIMIT?.setAmount ?? defaultFn;
  const lossLimitMode =
    tradePlanForm.exitTactics.LOSS_LIMIT?.lossLimitMode ?? 'AMOUNT';
  const setLossLimitMode =
    tradePlanForm.exitTactics.LOSS_LIMIT?.setLossLimitMode ?? defaultFn;
  return (
    <div className={style.container}>
      <div className={style.labelAndCheckbox}>
        <input
          style={{ margin: '0 5px 0 0' }}
          type="checkbox"
          checked={isEnabled}
          onChange={() => {
            if (isEnabled) {
              tradePlanForm.removeExitTactic('LOSS_LIMIT');
            } else {
              tradePlanForm.addExitTactic('LOSS_LIMIT');
            }
          }}
        />
        <Body3 fontWeight={700} color={colors.lightGrey}>Loss Limit</Body3>
      </div>
      <div className={style.controls}>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Unit</Body4>
          <BoxSwitch
            fontSize={fontSizes.body4}
            color="white"
            notSelectedColor="grey"
            selectedColor="green"
            controlledValue={lossLimitMode}
            labels={['$', '%']}
            values={['AMOUNT', 'PERCENT']}
            title="unit"
            setValue={setLossLimitMode}
          />
        </div>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Amount</Body4>
          <NumericalInput
            disabled={!isEnabled}
            width="50px"
            maxHeight="23px"
            icon={lossLimitMode === 'AMOUNT' ? '$' : '%'}
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={amount}
            onChange={setAmount}
          />
        </div>
      </div>
    </div>
  );
});
